
import { StrategyStats } from "../strategy/StrategyStats";

interface StrategyDetailStatsProps {
  riskLevel?: number; // Make riskLevel optional
  winRate?: number | null;
  maxDrawdown?: number | null;
  tradesWon?: number | null;
  tradesLost?: number | null;
  aum?: number | null;
  pnlRatio?: number | null;
  timespan?: number | null;
  isPro?: boolean;
  infoIconColor?: string; // Add the infoIconColor prop
}

const StrategyDetailStats = ({
  riskLevel,
  winRate,
  maxDrawdown,
  tradesWon,
  tradesLost,
  aum,
  pnlRatio,
  timespan,
  isPro = false,
  infoIconColor
}: StrategyDetailStatsProps) => {
  return (
    <StrategyStats 
      riskLevel={riskLevel}
      winRate={winRate}
      maxDrawdown={maxDrawdown}
      tradesWon={tradesWon}
      tradesLost={tradesLost}
      aum={aum}
      pnlRatio={pnlRatio}
      timespan={timespan}
      isPro={isPro}
      infoIconColor={infoIconColor}
    />
  );
};

export default StrategyDetailStats;
